export default "__VITE_ASSET__iA9s6WvE__"